var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.size > 0)?_c('input',{attrs:{"type":"checkbox","name":"layout","id":_vm.inputId,"disabled":(_vm.is_demo_user && !_vm.isDisabled) || !_vm.isDisabled},domProps:{"value":_vm.inputValue,"checked":_vm.checked}}):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f2b6174","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HkepCheckBox.vue
// module id = gYYd
// module chunks = 2 3 4 5 6